var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Icon ionic-ios-arrow-back","d":"M5.661 7.09L.3 12.45a1.013 1.013 0 101.432 1.43l6.077-6.073a1.011 1.011 0 00.03-1.4L1.737.3A1.013 1.013 0 00.3 1.726z","fill":"#f2f2f2"}));
}

Arrow.defaultProps = {"width":"8.104","height":"14.176"};

module.exports = Arrow;

Arrow.default = Arrow;
